module.exports = __webpack_public_path__ + "static/media/hz7.f78eaea8.png";